import React, { useState } from 'react';
import { Container, Card, Button, Form } from 'react-bootstrap';

const Genetic_data = () => {
  return (
    <div>
      <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <div style={{ maxWidth: '400px' }}>
          <Card className="d-flex align-items-center justify-content-center flex-column shadow-lg ">
            <Card.Body>
              <h2 className="text-center">Captura de datos</h2>
              <h6 className="text-center">Datos genéticos</h6>

              <hr />
              <Form>
                <div className="text-center">
                  <Button className="w-75 mt-3 text-center" type="submit">
                    Enviar datos
                  </Button>
                  <div className="text-center">
                    <a href="/capturar_datos"> Volver </a>
                  </div>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default Genetic_data;
